module.exports = __webpack_public_path__ + "assets/img/teacher (46).0a44d664.png";